import { useNavigate } from "react-router"
import PageMeta from "../../components/common/PageMeta"
import ChangePasswordForm from "../../components/settings/ChangePasswordForm"

// Ruta fija, NUNCA convertir en redirect — ProtectedRoute.tsx la excluye
// explícitamente del gate `mustChangePassword`, es la única pantalla
// alcanzable mientras ese gate está activo (gestion-staff-my-account
// design.md). El cambio voluntario de contraseña vive por separado en
// /account/security, con su propio copy.
export default function ChangePasswordPage() {
  const navigate = useNavigate()

  return (
    <>
      <PageMeta title="Cambiar contraseña | SateLab Gestión" description="Define una nueva contraseña para tu cuenta" />
      <div className="flex min-h-[70vh] items-center justify-center">
        <div className="w-full max-w-md rounded-2xl border border-gray-200 bg-white p-6 dark:border-gray-800 dark:bg-white/[0.03]">
          <h1 className="text-xl font-semibold text-gray-800 dark:text-white/90">Define tu contraseña</h1>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Tu cuenta se creó con una contraseña temporal. Antes de continuar, define una propia.
          </p>

          <div className="mt-6">
            <ChangePasswordForm onSuccess={() => navigate("/")} />
          </div>
        </div>
      </div>
    </>
  )
}
